import { Component, Input, OnInit } from '@angular/core';
import { NgClass, NgFor } from '@angular/common';
import { PopupTemperaturaRoteiroService } from '../../popup-temperatura-roteiro/popup-temperatura-roteiro.service';
import { PopupConfigService } from '../../popup-config/popup-config.service';



declare var bootstrap: any;
@Component({
    selector: 'app-info-roteiro-visita',
    templateUrl: './info-roteiro-visita.component.html',
    styleUrls: ['./info-roteiro-visita.component.css'],
    standalone: true,
    imports: [NgFor, NgClass]
})
export class InfoRoteiroVisitaComponent implements OnInit{
  @Input() roteiro: any;
  @Input() somenteTemperatura: boolean = false;

  tempMaxPermitida = 0;
  tempMaxPermitidaAtiva = false;
  informacoesRoteiro = [];

  constructor(private popupTemperaturaRoteiroService: PopupTemperaturaRoteiroService, private popupConfigService: PopupConfigService){}

  ngOnInit() {
    this.iniciaInfoRoteiro();
    this.popupConfigService.tempMaxPermitida$.subscribe((valor: number) => {
      this.tempMaxPermitida = valor;
    });

    this.popupConfigService.tempMaxPermitidaAtiva$.subscribe((valor: boolean) => {
      this.tempMaxPermitidaAtiva = valor;
    });
  }    

  iniciaInfoRoteiro(){
    if(this.somenteTemperatura && this.roteiro.temperaturaAtual != null){
      this.informacoesRoteiro = [];
      this.informacoesRoteiro.push({ titulo: 'Temp. Carga', valor: this.roteiro.temperaturaAtual + '°' })
    }
    else if(!this.somenteTemperatura){
    this.informacoesRoteiro = [
        { titulo: 'Roteiro', valor: this.roteiro.NumeroRoteiro },
        { titulo: 'Motorista', valor: this.roteiro.NomeMotorista },
        { titulo: 'Placa veículo', valor: this.roteiro.PlacaVeiculo }
      ]  
    }
  }

  abrirTemperaturaCarga(info: any) {
    if (info.titulo !== 'Temp. Carga') {
      return;
    }
    this.popupTemperaturaRoteiroService.numeroRoteiro = this.roteiro.NumeroRoteiro;
    const element = document.getElementById('popupID-temperatura-roteiro');
    if (element) {
      const modalInstance = new bootstrap.Modal(element);
      modalInstance.show();
    }
  }
}


